import { pdf } from '@/content/blocks'
import type { Project } from '@/types/content'

const project: Project = {
  slug: 'cswp-mechanical-design',
  title: 'CSWP — Mechanical Design',
  summary: 'Certified SolidWorks Professional in Mechanical Design.',
  cover: {
    src: '/assets/CSWP-MM2020.png',
    alt: 'Certified SolidWorks Professional badge',
  },
  tags: ['Certification'],
  order: 11,
  blocks: [
    pdf('/assets/Certificate_C-6CKVYE4XSM.pdf', 'CSWP-MD Certificate'),
  ],
}

export default project
